module.exports = __webpack_public_path__ + "static/media/TheSecretWorldofBriarRose_Case.f8535f6d.jpg";